import request from '../utils/request'

// 部门分页查询（分页+模糊查询，唯一分页入口）
export function getDepartmentList(data) {
  return request({
    url: '/department/page',
    method: 'post',
    data
  })
}

// 获取全部部门
export function getAllDepartments() {
  return request({
    url: '/department/all',
    method: 'get'
  })
}

// 根据ID获取部门详情
export function getDepartmentById(id) {
  return request({
    url: `/department/${id}`,
    method: 'get'
  })
}

// 创建部门
export function createDepartment(data) {
  return request({
    url: '/department',
    method: 'post',
    data
  })
}

// 更新部门
export function updateDepartment(data) {
  return request({
    url: '/department',
    method: 'put',
    data
  })
}

// 设置部门负责人/分管领导
export function updateDepartmentLeaders(data) {
  return request({
    url: '/department/leaders',
    method: 'put',
    data
  })
}

// 删除部门
export function deleteDepartment(id) {
  return request({
    url: `/department/${id}`,
    method: 'delete'
  })
}